import type { ModalDialogBodyProps } from "./modal-dialog.types";

import styles from "./modal-dialog-body.module.css";

export function ModalDialogBody({
  children,
  className = "",
  ...props
}: ModalDialogBodyProps) {
  return (
    <div className={`${styles.Container} ${className}`} {...props}>
      {children}
    </div>
  );
}
